export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAtehWj2WvXrYtZSC5ZmXA3H2OpBXwuNz8',
    authDomain: 'feev-dev-2023.firebaseapp.com',
    projectId: 'feev-dev-2023',
    storageBucket: 'feev-dev-2023.appspot.com',
    messagingSenderId: '450629957207',
    appId: '1:450629957207:web:8574daa5f581f38bd79512',
  },
  apiSeguranca: 'https://apisegurancahomolog.2safe.com/api/',
  apiCobranca: 'https://apicobrancahomolog.2safe.com/api/',
  apiMinhaConta: 'https://apiminhacontahomolog.2safe.com/api/',
  apiFeev: 'https://apifeev.feev.com/api/',
  codigoSistemaFeev: 5,
  appMinhaConta: 'https://minhacontahomolog.2safe.com',
  appFeev: 'https://apphomolog.feev.com.br',
  maxCodigoSistema: 7,
  apiCadastroFeev: 'https://a0xl7rlbod.execute-api.us-east-1.amazonaws.com/Prod/api/',
  apiCadastro: 'https://0ll1nieqoi.execute-api.us-east-1.amazonaws.com/Prod/api/',
  minhacontaUrl: "https://minhacontahomolog.2safe.com/",
  telefoneComercial: '0800 025 8984',
  // Site key do reCAPTCHA v3. Vazia = captcha desligado neste app; o interceptor
  // nem carrega o script do Google e nada muda no comportamento atual.
  recaptchaSiteKey: '6Ld6vM4tAAAAABOJpfIPJTzusp6tGL16wZoCCU1f',
  // Chave v2 (checkbox), usada só no desafio quando o score do v3 não passa.
  recaptchaSiteKeyV2: '6Lc1vs4tAAAAABhfwDiJsdZqELwueqZTuKS5fImd',
};
